module.exports = __webpack_public_path__ + "img/oog_ohol.05667abb.png";